var $ = jQuery.noConflict();

jQuery(window).on('load', function() {
    jQuery('.preloader-wrapper').addClass('done');
});

function hidePreloader() {
    jQuery('.preloader-wrapper').addClass('done');
}